if (!customElements.get("product-addition")) {
  class productAddition extends HTMLElement {
    constructor() {
      super();

      this.colourSwatches = this.querySelectorAll(".js-colour-swatch");
      this.image = this.querySelector(".js-additions-image");
      this.colourOption = this.querySelector(".js-colour-option");
      this.selectedVariant = this.querySelector(".js-product-addition");

      this.colourSwatches.forEach(swatch => {
        swatch.addEventListener("click", (e) => {
          e.preventDefault();
            this.updateSwatch(e.target);
        });
      });

      this.selectedVariant.addEventListener("change", (e) => {
        const product = e.currentTarget;
        if (product.checked) {
          this.customGtagEvent(product);
        }
      });
    }

    updateSwatch(swatch) {
      const handle = swatch.getAttribute("data-product-handle");
      const variantId = swatch.getAttribute("data-variant-id");
      const imageUrl = swatch.getAttribute("data-image");
      const color = swatch.getAttribute("data-color");

      fetchProductPrice(handle, variantId).then(price => {
        if (price) {
          this.querySelector(".price").innerHTML = price;
        }
      });

      this.colourSwatches.forEach(swatch => swatch.classList.remove("active"));
      swatch.classList.add("active");

      if (this.image && imageUrl) {
        this.image.src = imageUrl;
        this.image.srcset = `${imageUrl}&width=72 1x, ${imageUrl}&width=144 2x`;
      }

      if (this.colourOption) {
        this.colourOption.innerHTML = `<strong>${window.strings.color}:</strong> ${color}`;
      }

      if (this.selectedVariant) {
        this.selectedVariant.value = variantId;
      }
    }

    customGtagEvent(product) {
      const item = {
        item_id: product.value,
        item_name: product.dataset.name,
        item_variant: product.dataset.variant,
        price: parseFloat(product.dataset.price),
        quantity: 1 
      };

      gtag('event', 'selected_upsell', {
        currency: window.currency, 
        value: item.price, 
        items: [item]
      });
    }
  }
  customElements.define("product-addition", productAddition);
}

async function fetchProductPrice(handle, variantId) {
  try {
    const response = await fetch(`/products/${handle}?variant=${variantId}`);
    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");
    const priceElement = doc.querySelector(".js-product-price");
    return priceElement ? priceElement.innerHTML : null;
  } catch (error) {
    console.error("Error fetching product price:", error);
    return null;
  }
}